import React from "react";
import BannerCenter from "./BannerCenter";
import ServicesTabs from "./ServicesTabs";
import { tabsData } from "./tabsData";
import TwoCol from "./TwoCol";
import {
  twoColBannerData,
  standardsData,
  twoColData,
  twoColData2,
  twoColData3,
  translationProcessData,
  translationProcessData2,
  translationLanguagesData,
} from "./config";
import TranslationLanguages from "./TranslationLanguages";
import ClientsReviews from "./ClientsReviews";
import { Link } from "gatsby";
import Standards from "./Standards";
import TranslationProcess from "./TranslationProcess";
import ContactUs from "./ContactUs";
import Layout from "../layout";
import Seo from "../seo";

function TranslationServices() {
  return (
    <Layout>
      <Seo
        title="Translation Services - High-Quality and 100% Human"
        description="Translation services provided by 100% human translators. Get fast, accurate, and high-quality translations 24/7. Translate any text into more than 120 languages."
      />
      {/* <BannerCenter /> */}
      <div className="lg:hidden w-full px-4 2xl:px-0 py-7 shadow-2xl">
        <div className="flex max-w-7xl mx-auto gap-3 items-center text-base text-[#494949] font-opensans font-semibold">
          <Link to="/">
            <img
              src="https://tomedes.gumlet.io/S3UploadedFiles/1666089711home.svg"
              alt="home"
            />
          </Link>
          <img
            src="https://tomedes.gumlet.io/S3UploadedFiles/1666089692greater-than.svg"
            alt="navigate"
          />
          <span>Translation Services</span>
        </div>
      </div>
      <TwoCol
        data={twoColBannerData}
        background="bg-[#FBFCFF]"
        isBanner={true}
      />
      <div className="hidden lg:block w-full px-4 2xl:px-0 py-7 shadow-2xl">
        <div className="flex max-w-7xl mx-auto gap-3 items-center text-base text-[#494949] font-opensans font-semibold">
          <Link to="/">
            <img
              src="https://tomedes.gumlet.io/S3UploadedFiles/1666089711home.svg"
              alt="home"
            />
          </Link>
          <img
            src="https://tomedes.gumlet.io/S3UploadedFiles/1666089692greater-than.svg"
            alt="navigate"
          />
          <span>Translation Services</span>
        </div>
      </div>
      <Standards data={standardsData} />
      <TwoCol order="order-first" data={twoColData} />
      <TranslationProcess data={translationProcessData} />
      <ServicesTabs tabsData={tabsData} />
      <TwoCol
        order="order-first"
        data={twoColData2}
        background="bg-white pb-0"
      />
      <TranslationProcess
        data={translationProcessData2}
        background="bg-white xs:pt-4 xs:pb-[5rem]"
        textCenter={false}
      />
      <TranslationLanguages data={translationLanguagesData} />
      <TwoCol
        order="order-first"
        data={twoColData3}
        background="bg-white pb-0"
      />
      <ContactUs />
      <ClientsReviews />
    </Layout>
  );
}
export default TranslationServices;
